import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import client from '../../api/client';

export const fetchSpares = createAsyncThunk('spares/fetch', async (model = null) => {
  const url = model ? `/inventory/spares/?model=${encodeURIComponent(model)}` : '/inventory/spares/';
  const { data } = await client.get(url);
  return data;
});

const sparesSlice = createSlice({
  name: 'spares',
  initialState: { list: [], loading: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSpares.pending, (state) => { state.loading = true; })
      .addCase(fetchSpares.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      });
  },
});

export default sparesSlice.reducer;
